import styled, {css, keyframes} from 'styled-components';
import {RowStyles, ColumnStyles} from './../../../../../../stories/core-components/Layouts/Layouts';

export const Loader = styled.div`
  ${RowStyles}
  width: 100%
`;
export const LoaderColumn = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-self: flex-start;
`;
